import { Injectable } from '@angular/core';
import { DictionaryType } from '../../dictionary-type.enum';
import { DictionaryMode } from '../../dictionary-mode.enum';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMachineTypeDictionaryModel } from './machine-type-dictionary.model';
import { AppConfigurationService } from '../../../configuration/app-configuration.service';
import { DictionaryServiceBase } from '../common/dictionary-service-base';

@Injectable()
export class MachineTypeDictionaryService extends DictionaryServiceBase<IMachineTypeDictionaryModel[]> {
  constructor(
    private httpClient: HttpClient,
    private config: AppConfigurationService
  ) {
    super();
  }

  type: DictionaryType = DictionaryType.MachineType;
  mode: DictionaryMode = DictionaryMode.Static;

  loadData(): Observable<IMachineTypeDictionaryModel[]> {
    const url = `${this.config.configuration.api_url}/api/definitions/machinetypes`;
    return this.httpClient.get<IMachineTypeDictionaryModel[]>(url);
  }
}
